var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"not-found-all"},[_c('div',[_c('div',{staticClass:"novue"},[_vm._v("404")]),_c('div',[_vm._v("您访问的页面走丢啦")])])])}]

export { render, staticRenderFns }